<template>
  <div>
    <router-view />
    <div class="audio-box" :class="{'audio-box1':true}" v-show="isBox">
            <div class="audio-container">
                <div class="audio-view">
                    <div class="audio-body">
                        <!-- <h3 class="audio-title">未知歌曲</h3> -->
                        <div class="audio-backs">
                            <div class="audio-this-time">00:00</div>
                            <div class="audio-count-time">00:00</div>
                            <div class="audio-setbacks">
                                <i class="audio-this-setbacks">
                                    <span class="audio-backs-btn"></span>
                                </i>
                                <span class="audio-cache-setbacks">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="audio-btn">
                        <div class="audio-select">
                            <div action="play" data-on="icon-play" data-off="icon-pause" class="icon-play"></div>
                            <!--<div action="menu" class="icon-list-alt"></div>-->
                            <div action="volume" class="icon-volume-up">
                                <div class="audio-set-volume">
                                    <div class="volume-box">
                                        <i><span  class="audio-backs-btn"></span></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
  </div>
  
</template>

<script>
  import './assets/css/font.css'
  import './assets/css/audio.css'
  import './assets/js/audio.js'
  export default {
    name: 'App',
    data(){
      return{
        isBox:false
      }
    },
    watch:{
      '$route'(to,from){
        if(to.path == '/'){
          this.isBox = false
        }else{
          this.isBox = true
        }
      }
    },
    mounted(){
      var setConfig = {
          song : [
              {
                  title : 'china',
                  src : 'static/musiz/bc.mp3' 
              }
          ],
          error : function(meg){
              console.log(meg);
          }
      };
      var audioFn = audioPlay(setConfig);
      if(audioFn){
          //开始加载音频,true为播放,false不播放
          audioFn.loadFile(1);
      }
    }
  }
</script>

<style lang="scss" scoped>
  // .audio-box{
  //   bottom:10px;
  //   z-index:-1;
  //   opacity:0;
  // }

  @media(max-width:768px){
    .audio-box{
            width:100%;
            bottom:0; left:0; 
            right:0;

            .audio-body{
                width:calc(100% - 50px);
            }
            .audio-btn{
                width:50px;
            }
            .audio-setbacks{
                width:100%;
            }
            .audio-select{
                width:100%;
            }
            .icon-volume-up{
                display:none;
            }
        }
  }
</style>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
